'use client';
import { useAuthStore } from '@/stores/auth-store';

import { useQuery } from '@tanstack/react-query';
import { createClient } from '@/lib/supabase/client';
import { getDefaultTenantId } from '@/lib/supabase/query-context';
import {
  SETTINGS_VISIBILITY_PAGE_KEY,
  SETTINGS_VISIBILITY_PREF_TYPE,
  parseSettingsVisibilityPreference,
} from '@/lib/settings/settings-visibility';

export function useSettingsHiddenLeaves() {
  const tenantId = useAuthStore((state) => state.user?.tenantId);
  return useQuery({
    queryKey: ['settings-hidden-leaves', tenantId],
    enabled: Boolean(tenantId),
    queryFn: async () => {
      const sb = createClient();
      if (!tenantId || (await getDefaultTenantId()) !== tenantId)
        throw new Error('Settings tenant context changed.');
      const { data, error } = await sb
        .from('layout_preferences')
        .select('visible_keys, key_order')
        .eq('tenant_id', tenantId)
        .is('user_id', null)
        .eq('page_key', SETTINGS_VISIBILITY_PAGE_KEY)
        .eq('pref_type', SETTINGS_VISIBILITY_PREF_TYPE)
        .maybeSingle();
      if (error) throw error;
      return parseSettingsVisibilityPreference(
        (data?.visible_keys as Record<string, unknown> | null) ?? null,
        (data?.key_order as string[] | null) ?? null,
      ).hiddenHrefs;
    },
    staleTime: 60_000,
  });
}
